module.exports = __webpack_public_path__ + "img/title.781fd787.png";